const routes = {
  '*/calendar/:danceschoolSlug/:calendarId': ['calendar/controllers', 'klasses'],
  '*/calendar/:danceschoolSlug/:calendarId/:view': ['calendar/controllers', 'klasses'],
};

export default routes;
